import React from 'react';

import { BaseModal, Button } from '@cokitchen/cokitchen-components';

interface ConfirmUndoModalProps {
  showUndoModal: boolean;
  onClose: () => void;
  onConfirm: () => void;
}
const ConfirmUndoModal: React.FC<ConfirmUndoModalProps> = ({
  showUndoModal,
  onClose,
  onConfirm
}) => {
  return (
    <BaseModal
      isOpen={showUndoModal}
      title=''
      onRequestClose={onClose}
      footer={
        <div className='flex gap-4 items-center'>
          <Button onClick={onClose} color='gray' variant='block'>
            Cancel
          </Button>
          <Button onClick={onConfirm} color='primary' variant='block'>
            Undo
          </Button>
        </div>
      }>
      <div className='flex flex-col items-center pt-6'>
        <p className='text-lg'>Are you sure you want to undo the changes?</p>
      </div>
    </BaseModal>
  );
};

export default ConfirmUndoModal;
